// import { createLogger } from 'redux-logger';
import { loadingBarMiddleware } from 'react-redux-loading-bar';
import { applyMiddleware, compose, createStore } from 'redux';
// redux-thunk  -handle asynchronous actions in Redux.
import thunk from 'redux-thunk';

import { rootReducer } from './rootReducer';
// Compose-Used to pass multiple store enhancers to the store
// preloadedState (optional): represents initial redux state (rendered on
// server)
const configureStore = (preloadedState?: any) => {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      // applyMiddleware(thunk, loadingBarMiddleware(), createLogger()),
      applyMiddleware(thunk, loadingBarMiddleware())
    )
  );
  return store;
};

export default configureStore;
